import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LocalisationService {
    private enUS = new Subject<any[]>();
    
    set(message: any[]) {
        this.enUS.next(message);
    }
    clear() {
        this.enUS.next();
    }
    get(): Observable<any[]> {
        return this.enUS.asObservable();
    }


}